<div class="modal-header">
  <h5 class="modal-title">View Count</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-inner-body">
  <p *ngIf="loading" class="text-muted">Loading...</p>
  <p *ngIf="errorMessage" class="text-danger">{{ errorMessage }}</p>
  <div *ngIf="!loading && !errorMessage">
    <table class="table table-sm table-striped" *ngIf="totalViewCount > 0">
      <thead>
        <tr>
          <th>Video</th>
          <th class="text-center">Total Count</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of viewCounts">
          <td>{{ item.videoTitle || item.videoId }}</td>
          <td class="text-center">{{ item.count }}</td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="totalViewCount === 0" class="text-muted mb-0 view-count-empty">No video view count.</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
</div>
